<div class="patientReactivateDialog">
  <mat-dialog-content>
    <h3>{{ "page.patientlist.activatePatientConfirm" | translate }}</h3>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close>
      {{ "btn.cancel" | translate }}
    </button>
    <button mat-button class="updateDeactivationButton" (click)="onChoice(choices.UPDATE_DEACTIVATION)">
      {{ "model.patient.disablePatientType.updateOption" | translate }}
    </button>
    <button mat-button color="primary" cdkFocusInitial (click)="onChoice(choices.ACTIVATE)">
      {{ "page.patientlist.activatePatientSolo" | translate }}
    </button>
  </mat-dialog-actions>
</div>
